import * as React from 'react';
/**
 *
 * Original name: thumbs up
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A540
 *
 */
export const ThumbsUpSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M98.436 52.443A8.947 8.947 0 0 0 91.356 49H72.162L75.7 38.376A17.001 17.001 0 0 0 59.576 16h-4.738l-7.124 21.37a11.041 11.041 0 0 1-4.487 5.775l-6.391 4.108A10.98 10.98 0 0 1 30.888 49H19v34.8l25.159 13.474A23.08 23.08 0 0 0 55.02 100h28.27a8.976 8.976 0 0 0 8.742-6.863l8.067-33a8.947 8.947 0 0 0-1.663-7.694Zm-4.165 6.27-8.067 33A2.992 2.992 0 0 1 83.29 94H55.02a17.058 17.058 0 0 1-8.028-2.015L25 80.2V55h5.888c3.26.002 6.452-.935 9.193-2.7l6.391-4.108a17.06 17.06 0 0 0 6.935-8.924L59.162 22h.414a11 11 0 0 1 10.435 14.479L63.838 55h27.518a3 3 0 0 1 2.915 3.712v.001Z", fill: "currentColor" })));
